import { DefaultQueryParams, PaginatedResponse } from '@frontend/api-utils';
import { EntityType } from '@frontend/common';
import { Application, Feature } from '@frontend/functionality/types';

export interface TransactionRule {
    delete_timestamp: string | null;
    name: string;
    application: Application | null;
    feature: Feature | null;
    quantity: number;
    period: TransactionRulePeriod | null;
    every: number | null;
    id: string;
    account_id: string;
    creation_timestamp: string;
    update_timestamp: string;
}

export interface CreateTransactionRule {
    name?: string;
    application?: Application | null;
    feature?: Feature | null;
    quantity?: number;
    period?: TransactionRulePeriod | null;
    every?: number | null;
}

export interface UpdateTransactionRule {
    null_fields?: string[] | null;
    name?: string | null;
    application?: Application | null;
    feature?: Feature | null;
    quantity?: number | null;
    period?: TransactionRulePeriod | null;
    every?: number | null;
}

export interface TransactionRuleEntity {
    entity_type: EntityType;
    entity_id: string;
    id: string;
    account_id: string;
    rule_id: string;
    creation_timestamp: string;
}

export interface CreateTransactionRuleEntity {
    entity_type: EntityType;
    entity_id: string;
}

export enum TransactionRulePeriod {
    HOUR = 'hour',
    DAY = 'day',
    WEEK = 'week',
    MONTH = 'month',
    YEAR = 'year',
    FULL_PERIOD = 'full_period'
}

enum QueryParams {
    ACCOUNT_ID = 'account_id',
    APPLICATION = 'application',
    FEATURE = 'feature',
    ENTITY_TYPE = 'entity_type',
    ENTITY_ID = 'entity_id',
    RULE_ID = 'rule_id'
}

export type TransactionRuleQueryParams = DefaultQueryParams & QueryParams;
export type TransactionRuleEntityQueryParams = DefaultQueryParams & QueryParams;
export type TransactionRuleListResponse = PaginatedResponse<TransactionRule>;
export type TransactionRuleEntityListResponse = PaginatedResponse<TransactionRuleEntity>;
